import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormTitle,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'title',
          label: 'Title',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'level',
          label: 'Level',
          valueComponent: {
            type: 'Select',
            options: [
              { label: '1', value: 1 },
              { label: '2', value: 2 },
              { label: '3', value: 3 },
              { label: '4', value: 4 },
              { label: '5', value: 5 },
            ],
            defaultValue: 1,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'type',
          label: 'Type',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Default', value: 'default' },
              { label: 'Secondary', value: 'secondary' },
              { label: 'Success', value: 'success' },
              { label: 'Warning', value: 'warning' },
              { label: 'Danger', value: 'danger' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'True', value: true },
              { label: 'False', value: false },
            ],
            defaultValue: true,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'copyable',
          label: 'Copyable',
          valueComponent: { type: 'Switch' },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
